module.exports = __webpack_public_path__ + "static/img/8.5d9fce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/8.png
// module id = 1fs2
// module chunks = 0